import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import { CopyButton } from 'src/Containers/ui/CopyButton/CopyButton'

export const StyledCopyButton = styled(CopyButton)`
  height: 48px;
  width: fit-content;
  width: calc(100% / 3 - 16px);
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

export const ReferralLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: inherit;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  line-height: 150%;
  white-space: nowrap;
  &:hover {
    color: ${({ theme }) => theme.color.slateGrey};
  }
  &:focus {
    color: ${({ theme }) => theme.color.slateGrey};
  }
`

export const InviteBlockContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.lightGrey};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    box-shadow: none;
    border: none;
    padding: 0;
  }
`
export const Description = styled.div`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
`
export const InviteBlockTitle = styled.div`
  font-family: Segoe UI;
  color: ${({ theme }) => theme.color.darkGrey};
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`
export const ButtonsBlock = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: column;
  }
`
